import {IEncrypter} from "./IEncrypter";
import SimpleCrypto from "simple-crypto-js";

export default class SimpleCryptoEncrypter implements IEncrypter {
  private readonly _key = "-4*A_mJG[8r2F$^B9çm$!uZ7&";
  private readonly _crypto: SimpleCrypto;

  constructor() {
    this._crypto = new SimpleCrypto(this._key);
  }

  public decrypt(ciphered: string): string {
    return this._crypto.decrypt(ciphered) as string;
  }

  public encrypt(data: string): string {
    return this._crypto.encrypt(data);
  }

}
